import React from 'react';

import Brochure from '../components/Brochure';

import Layout from '../../travelerProfile/layouts/TravelerProfile';
import DetailPageWrapper from '../../travelerProfile/components/base/DetailPageWrapper'

const tabTitleMap = {
  academics: 'Academics',
  resources: 'Resources',
  eligibility: 'Eligibility',
  'about-program': 'About Program',
  'whats-included': `What's Included`,
  'cost-and-funding': 'Cost & Funding',
  'term-information': 'Term Information',
};

export default function Page({ params }) {
  return {
    title: `Brochure | ${params.tab ? tabTitleMap[params.tab] : 'Program Overview'}`,
    component: (
      <Layout allowNoUser={true}>
        <DetailPageWrapper routeSegment="program_brochure">
          <Brochure {...params} />
        </DetailPageWrapper>
      </Layout>
    ),
  };
}
